var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"content-pane"}},[(_vm.routing)?_c('loading',{attrs:{"delay":200}}):_c('div',[_c('router-view',{key:_vm.key}),_c('copyright')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }